import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NRDAY_65: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NRDAY_65_N,
  },
  {
    pageId: PageId.CHAT_UPSELL_NRDAY_65,
  },
  {
    pageId: PageId.UPSELL_NRDAY_65,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_NRDAY_65,
  },
]
